import styleAf from "./Affiliate.module.scss";
import "./../../../index.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ReactComponent as UP } from "../../../assets/images/Arrow_up.svg";
import { ReactComponent as DOWN } from "../../../assets/images/Arrow_down.svg";
import { ReactComponent as SAVINGS } from '../../../assets/images/savings.svg';
import { ReactComponent as ANALYT } from '../../../assets/images/analytics.svg';
import { ReactComponent as NOTES } from '../../../assets/images/clinical_notes.svg';
import { ReactComponent as CURS } from '../../../assets/images/round_and_cursor.svg';
import { ReactComponent as DEPOSITORS } from '../../../assets/images/wallet_vip.svg';
import { convertFeeToPrecent, formatNumber, roundTo } from "../../../_utils";
import { AffiliateStats, AffiliateStatsTitle } from "../../../interfaces";
import { ErrorBoundary } from "../../common";

const emptyStats = {
  totalRevenue: null,
  linkClicks: null,
  registrations: null,
  firstTimeDepositors: null,
  totalTradingVolume: null,
  totalFees: null
}

export const AffBolcks = ({ summaryStats = emptyStats, activeStat, setActiveStat, feeShare }) => {
  const { t } = useTranslation();

  return (
    <div className={styleAf.info_cont}>
      <AffStatBlock 
        title={t(AffiliateStatsTitle.totalRevenue)} 
        icon={<SAVINGS />}
        value={`$${formatNumber(roundTo(summaryStats?.totalRevenue?.value, 2))}`} 
        change={summaryStats?.totalRevenue?.trend}
        isActive={activeStat === AffiliateStats.totalRevenue}
        setActive={() => setActiveStat(AffiliateStats.totalRevenue)}
      />
      <AffStatBlock 
        title={t(AffiliateStatsTitle.linkClicks)} 
        icon={<CURS />}
        value={summaryStats?.linkClicks?.value} 
        change={summaryStats?.linkClicks?.trend}
        isActive={activeStat === AffiliateStats.linkClicks}
        setActive={() => setActiveStat(AffiliateStats.linkClicks)}
      />
      <AffStatBlock 
        title={t(AffiliateStatsTitle.registrations)} 
        icon={<NOTES />}
        value={summaryStats?.registrations?.value} 
        change={summaryStats?.registrations?.trend}
        isActive={activeStat === AffiliateStats.registrations}
        setActive={() => setActiveStat(AffiliateStats.registrations)}
      />
      <AffStatBlock 
        title={t(AffiliateStatsTitle.firstTimeDepositors)} 
        icon={<DEPOSITORS />}
        value={summaryStats?.firstTimeDepositors?.value} 
        change={summaryStats?.firstTimeDepositors?.trend}
        isActive={activeStat === AffiliateStats.firstTimeDepositors}
        setActive={() => setActiveStat(AffiliateStats.firstTimeDepositors)}
      />
      <AffStatBlock 
        title={t(AffiliateStatsTitle.totalTradingVolume)} 
        icon={<ANALYT />}
        value={`$${formatNumber(roundTo(summaryStats?.totalTradingVolume?.value, 2))}`} 
        change={summaryStats?.totalTradingVolume?.trend}
        isActive={activeStat === AffiliateStats.totalTradingVolume}
        setActive={() => setActiveStat(AffiliateStats.totalTradingVolume)}
      />
      <AffStatBlock 
        title={t(AffiliateStatsTitle.totalFees)} 
        icon={<span className={styleAf.fee_share}>
          <span>{ t("affiliates.your_share") }</span>
          {convertFeeToPrecent(feeShare)}%
        </span>}
        value={`$${formatNumber(roundTo(summaryStats?.totalFees?.value, 2))}`} 
        change={summaryStats?.totalFees?.trend}
        isActive={activeStat === AffiliateStats.totalFees}
        setActive={() => setActiveStat(AffiliateStats.totalFees)}
      />
    </div>
  )
}

const AffStatBlock = ({ title, icon, value, change, isActive, setActive }) => (
  <div className={classNames(styleAf.info_item, {[styleAf.active_info_item]: isActive})} onClick={setActive}>
    <ErrorBoundary>
    <p>
      { title }
      { icon }
    </p>
    <p className={styleAf.info_value}>{ value ?? 0 }</p>
    { !!change &&
      <p className={classNames(styleAf.info_stat, change > 0 ? "text_green" : "text_red")}>
        {change > 0 && "+"} { Math.abs(change) > 999 ? "999+" : roundTo(change, 2) }
        %
        {change > 0 ? <UP /> : <DOWN />}
      </p>
    }
    </ErrorBoundary>
  </div>
)